import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=6f189e8c&scoped=true&"
import script from "./PublicLayout.vue?vue&type=script&lang=ts&"
export * from "./PublicLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=6f189e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f189e8c",
  null
  
)

export default component.exports